<template>
  <CModal
    :show.sync="isVisible"
    size="lg"
    centered
  >
    <template #header>
      <div>
        <div class="d-flex align-items-center">
          <CIcon name="cipUpload" size="custom-size" width="36" height="36"
                 class="mr-3 icon-circle icon-circle--primary"/>
          <div>
            <h5 class="modal-title">
              <translate translate-context="collaborators.ftp">FTP credentials</translate>
            </h5>
          </div>
        </div>
      </div>
      <CButtonClose @click="close"/>
    </template>
    <FtpCredentialDisplay
      v-if="credentials"
      :credentials="credentials"
    />

    <div v-else class="text-center text-muted py-4">
      <translate translate-context="collaborators.ftp">No FTP credentials available</translate>
    </div>

    <template #footer>
      <CButton color="primary" @click="close">
        <translate translate-context="collaborators.ftp">Close</translate>
      </CButton>
    </template>
  </CModal>
</template>

<script>
import FtpCredentialDisplay from './FtpCredentialDisplay.vue'

export default {
  name: 'FtpCredentialsModal',

  components: {
    FtpCredentialDisplay
  },

  data() {
    return {
      isVisible: false,
      email: '',
      credentials: null
    }
  },

  computed: {
    modalTitle() {
      return this.$pgettext('collaborators.ftp', 'FTP Credentials') + (this.email ? ` - ${this.email}` : '')
    }
  },

  methods: {
    close() {
      this.isVisible = false
    },
    show(email, ftpCredentials) {
      this.email = email || ''
      this.credentials = ftpCredentials || null
      this.isVisible = true
    }
  }
}
</script>
